import React, { Component, PureComponent } from "react";
import { line } from "d3-shape";

const GraphLine = class extends Component {
  constructor(props) {
    super(props);
    this.state = { hoveredIndex: null };
  }

  shouldComponentUpdate(nextProps){
    return true// this.props.rerender !== nextProps.rerender
  }

  render(props, state) {
     console.log("graphline rerenders")
    let {
      _data,
      xScale,
      yScale,
      color,
      sensorName,
      pointSelected,
    } = this.props;

    const style = {
      graphLine: {
        fill: "none",
        stroke: color,
        strokeWidth: 2
      }
    };

    if (!_data || _data.length < 1) {
      return null;
    }


    var lineGenerator = line()
      .x(function(d) {
        return xScale(Date.parse(d.date));
      })
      .y(function(d) {
        return yScale(parseFloat(d.value));
      });

    let pathData = lineGenerator(_data);

    var path = <path style={style.graphLine} d={pathData} />;

    // Circles: Full for last datapoint, hollow and small for others
    let lastDataPoint = _data[_data.length - 1];
    let lastPoint = (
      <GraphLineCircle
        radius="4"
        color={color}
        full="true"
        cx={xScale(Date.parse(lastDataPoint.date))}
        cy={yScale(lastDataPoint.value)}
      />
    );

    // Hover elements
/*     let hoverElements = [];
    _data.forEach((dataPoint, i) => {
      try {
        let previousX = 0,
          nextX = 0,
          currentX = 0,
          x,
          w;
        currentX = xScale(Date.parse(_data[i].date));
        if (_data.length < 2) {
          return;
        }
        if (i === 0) {
          nextX = xScale(Date.parse(_data[i + 1].date));
          x = currentX - (nextX - currentX) / 2;
          w = nextX - currentX;
        } else if (i >= _data.length - 1) {
          previousX = xScale(Date.parse(_data[i - 1].date));
          x = (currentX + previousX) / 2;
          w = currentX - previousX;
        } else {
          previousX = xScale(Date.parse(_data[i - 1].date));
          nextX = xScale(Date.parse(_data[i + 1].date));
          x = (currentX + previousX) / 2;
          w = (nextX - previousX) / 2;
        }
        hoverElements.push(

          <GraphLineHoverAreas
            key={i}
            color={color}
            full={false}
            cx={x}
            width={w} //{nextX-previousX-2}
            cy={yScale(dataPoint.value)}
            onMouseEnter={evt => {
              //console.log("onmouseenter", sensorName, evt.nativeEvent);
              console.log("EVT", evt.target.parentElement.parentElement);
              let origTarget = evt.target;
              //window.setTimeout(()=>{origTarget.style.pointerEvents = "all";}, 100)
              pointSelected({
                [sensorName]: {
                  x: xScale(Date.parse(dataPoint.date)),
                  y: yScale(dataPoint.value),
                  date: dataPoint.date,
                  value: dataPoint.value
                }
              });
              //this.setState({ hoveredIndex: i });

              // window.setTimeout(() => {
              //   origTarget.style.pointerEvents = "none";
              // }, 10);
              // window.setTimeout(() => {
              //   origTarget.style.pointerEvents = "all";
              // }, 50);
            }}
            onMouseLeave={evt => {
              //let origTarget = evt.target;
              //evt.persist();
              //evt.nativeEvent.stopImmediatePropagation();
              //evt.stopPropagation();
              //window.setTimeout(()=> {origTarget.style.pointerEvents = "none";},0);
              
              //this.setState({hoveredIndex: null})
              //console.log("onmouseleave on graphhoverarea")
              // window.setTimeout(()=> {origTarget.style.pointerEvents = "none";},0)
              //window.setTimeout(()=> {origTarget.style.pointerEvents = "all";},500)
            }}
          />
       
       );
      } catch (error) {
        return null;
      }
    }); */

    // Hover indicator
    let hoverInd = null;
    if (this.state.hoveredIndex !== null) {
      let dataPoint = _data[this.state.hoveredIndex];
      hoverInd = (
        <GraphLineCircle
          cx={xScale(Date.parse(dataPoint.date))}
          cy={yScale(dataPoint.value)}
          radius={6}
          full={true}
          color={color}
        />
      );
    }

    return (
      <g shapeRendering="geometricPrecision" id={sensorName}>
        {path}
        {/* { <g style={{ opacity:0 }}>{hoverElements}</g> } */}
       
        {lastPoint}
      </g>
    );
  }
};

const GraphLineHoverAreas = class extends PureComponent {
  render() {
    let { cx, width, color, onMouseEnter, onMouseLeave } = this.props;

    let style = { fill: color, stroke: color, strokeWidth: 1, opacity: 0.2 };
    return (
      <rect
        style={style}
        x={cx}
        y={0}
        width={width}
        height={"100%"}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    );
  }
};

const GraphLineCircle = class extends PureComponent {
  render() {
    let {
      cx,
      cy,
      radius,
      full,
      color,
      onMouseEnter,
      onMouseLeave
    } = this.props;

    let style = full
      ? { fill: color, stroke: "none", strokeWidth: 2, pointerEvents: "none" }
      : { fill: "white", stroke: color, strokeWidth: 2, pointerEvents: "none" };
    return (
      <circle
        style={style}
        cx={cx}
        cy={cy}
        r={radius}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    );
  }
};

export default GraphLine;
